// based on http://stackoverflow.com/a/9039885/177710

var iOS_PLATFORM_LIST = ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'];
var iosRegExp = new RegExp(iOS_PLATFORM_LIST.join('|'), 'gi');
var _getMobileOS = function _getMobileOS(navigatorInterface, documentInterface) {
  var _navigatorInterface$u;
  // Проверка на Android
  if (/android/i.test(navigatorInterface.userAgent)) {
    return 'android';
  }

  // Используем navigator.userAgentData, если доступен, иначе navigator.platform
  var platform = (navigatorInterface === null || navigatorInterface === void 0 ? void 0 : (_navigatorInterface$u = navigatorInterface.userAgentData) === null || _navigatorInterface$u === void 0 ? void 0 : _navigatorInterface$u.platform) || (navigatorInterface === null || navigatorInterface === void 0 ? void 0 : navigatorInterface.platform);
  if (iOS_PLATFORM_LIST.includes(platform || '') || navigatorInterface.userAgent.includes('Mac') && 'ontouchend' in documentInterface) {
    return 'ios';
  }
  return null;
};

/*
 * Для SSR значение userAgent передаётся с бэкенда.
 */
export var getMobileOS = function getMobileOS() {
  var _userAgent$match;
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (typeof window !== 'undefined') {
    // Клиентский рендеринг
    return _getMobileOS(window.navigator, window.document);
  }

  // SSR: если window не доступен, используем переданный userAgent
  var mockNavigator = {
    userAgent: userAgent,
    platform: '',
    userAgentData: {
      // Небольшой костыль, чтобы при SSR корректно сработала проверка для iOS
      platform: ((_userAgent$match = userAgent.match(iosRegExp)) === null || _userAgent$match === void 0 ? void 0 : _userAgent$match[0]) || ''
    }
  };
  return userAgent ? _getMobileOS(mockNavigator, {}) : null;
};